import { tryGetDataType } from '@medplum/core'
import type { AccessPolicyResource, Resource } from '@medplum/fhirtypes'
import { union } from 'lodash-es'

export function buildAccessPolicyResource(
  resource: Resource,
  visibleFields?: string[],
  hiddenFields?: string[],
  readonlyFields?: string[]
): AccessPolicyResource {
  const typeSchema = tryGetDataType(resource?.resourceType)

  const paths = Object.keys(typeSchema?.elements ?? {}).map((path) => path)

  const fieldsToHide = visibleFields
    ? paths.filter((field) => !visibleFields.includes(field))
    : (hiddenFields ?? [])

  return {
    resourceType: resource?.resourceType,
    hiddenFields: fieldsToHide,
    readonlyFields: readonlyFields ?? [],
  }
}

export function mergeAccessPolicyResource(
  a?: AccessPolicyResource,
  b?: AccessPolicyResource
): AccessPolicyResource | undefined {
  if (a && !b) {
    return a
  } else if (!a && b) {
    return b
  } else if (a && b) {
    return {
      resourceType: a.resourceType ?? b.resourceType,
      hiddenFields: union(a?.hiddenFields ?? [], b?.hiddenFields ?? []),
      readonlyFields: union(a?.readonlyFields ?? [], b?.readonlyFields ?? []),
    }
  }
  return undefined
}
